/** Empty for import precedence: null, undefined, or whitespace-only string. */
export function isEmptyImportValue(value: unknown): boolean {
  if (value === null || value === undefined) return true
  if (typeof value === 'string') return value.trim() === ''
  return false
}
